import { render } from "./ProdukModal_c.vue?vue&type=template&id=798695c9&scoped=true"
import script from "./ProdukModal_c.vue?vue&type=script&lang=js"
export * from "./ProdukModal_c.vue?vue&type=script&lang=js"

import "./ProdukModal_c.vue?vue&type=style&index=0&id=798695c9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-798695c9"

export default script